import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@lciapps/auth';

@Component({
  selector: 'app-signout',
  template: ``
})
export class SignoutComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    this.authService.completeSignoutMainWindow().then(() => {
      this.router.navigate(['/']);
    });
  }

}
